export default "__VITE_ASSET__DASTmmkT__"